'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var index = require('../../node_modules/react-lines-ellipsis/lib/index.js');
var EditAndDelete = require('../EditAndDelete.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  answerSpacing: {
    paddingBottom: 30
  },
  verticalTextLayout: {
    marginTop: 13.5,
    marginBottom: 13.5
  },
  answerText: {
    whiteSpace: 'pre-line'
  },
  faqQuestionText: {
    fontSize: 18,
    fontWeight: 400,
    fontFamily: 'Open sans, Roboto, Lato, Arial, sans-serif'
  }
};

function SingleFAQ(_ref) {
  var classes = _ref.classes,
      faq = _ref.faq,
      _onEditClick = _ref.onEditClick,
      _onDeleteClick = _ref.onDeleteClick,
      canEdit = _ref.canEdit,
      canDelete = _ref.canDelete,
      showAnswer = _ref.showAnswer;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: true,
    className: classes.verticalTextLayout
  }, React__default["default"].createElement(index, {
    className: classes.faqQuestionText,
    text: faq.question,
    maxLine: 1,
    ellipsis: "...",
    basedOn: "words"
  })), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(EditAndDelete, {
    onEditClick: function onEditClick() {
      return _onEditClick();
    },
    onDeleteClick: function onDeleteClick() {
      return _onDeleteClick();
    },
    canEdit: canEdit,
    canDelete: canDelete
  })))), showAnswer && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.answerSpacing
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body1",
    className: classes.answerText
  }, faq.answer)));
}

SingleFAQ.defaultProps = {
  onEditClick: function onEditClick() {},
  onDeleteClick: function onDeleteClick() {},
  showAnswer: true
};
var SingleFAQ$1 = withStyles(styles)(SingleFAQ);

module.exports = SingleFAQ$1;
